import React, { memo, forwardRef } from "react";
const SvgNaturallogarithmicbase = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.52 16.72c.027.347.113.667.26.96.16.28.367.527.62.74.253.2.54.36.86.48.32.12.653.18 1 .18.507 0 .92-.073 1.24-.22.333-.147.653-.347.96-.6.173-.147.32-.24.44-.28.12-.04.247-.06.38-.06.267 0 .493.087.68.26.187.173.28.407.28.7 0 .107-.027.24-.08.4-.053.16-.16.313-.32.46a4.457 4.457 0 01-1.56 1c-.56.2-1.227.3-2 .3a6.015 6.015 0 01-2.06-.34 5.112 5.112 0 01-1.64-1 4.669 4.669 0 01-1.08-1.56c-.253-.627-.38-1.333-.38-2.12 0-.773.127-1.473.38-2.1.267-.64.627-1.18 1.08-1.62.453-.453.987-.8 1.6-1.04a5.34 5.34 0 012.02-.38c.573 0 1.12.087 1.64.26.52.16.98.413 1.38.76.4.333.733.76 1 1.28.28.52.467 1.133.56 1.84.013.107.02.2.02.28.013.067.02.14.02.22 0 .427-.113.733-.34.92-.213.187-.52.28-.92.28h-6.04zM18.44 15c0-.307-.047-.6-.14-.88a1.902 1.902 0 00-.4-.74 1.888 1.888 0 00-.72-.5c-.28-.133-.613-.2-1-.2-.72 0-1.333.22-1.84.66-.493.427-.767.98-.82 1.66h4.92z"
      />
    </svg>
  );
});
SvgNaturallogarithmicbase.displayName = "SvgNaturallogarithmicbase";
const MemoForwardRef = memo(SvgNaturallogarithmicbase);
export default MemoForwardRef;
